import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {SessionService} from '../services/session.service';
import {DateEncoding} from '../model/DateEncoding';
import {Utils} from "../model/Utils";


// import { MobileSchedule } from '../model/common.model';


@Pipe({
    name: 'displayInterval'
})

export class DisplayInterval implements PipeTransform {

  private _formatAMPM: boolean;

  constructor(private session: SessionService ) {
    this._formatAMPM = false;
    if (this.session){
      this._formatAMPM = this.session.userInfo.isAMPM();
    }
  }

  public get formatAMPM(){
    return this._formatAMPM;
  }

    transform(value: number, overnight?:number): any {
      /*
      this.formatAMPM = false;
      // this.maskStartEndTime = DlgEditPlanningDetailComponent.HOUR_FORMAT_24;
      if ('en-US' === this.session.userInfo.locale) {
        this.formatAMPM = true;
        // this.maskStartEndTime = DlgEditPlanningDetailComponent.HOUR_FORMAT_AM_PM;
      }
      */
      return this.display(value, this.formatAMPM,overnight);
    }

    public display(value: number, formatAMPM: boolean, overnight?:number) {
     if (Utils.isNullOrUndefined(value)){
       return '';
     }

      const encoding = new DateEncoding();

      const dates = encoding.retrieveDates(value);

      if (dates.length === 2) {

        if (!Utils.isNullOrUndefined(overnight)){

          const dtOverNight = encoding.retrieveDates(overnight);
          if (dtOverNight.length === 2){
            return this.displayDates(dates[0],dtOverNight[1],formatAMPM);
          }else{
            console.log('DisplayInterval: No Overnight ' + overnight);
            return this.displayDates(dates[0], dates[1], formatAMPM);
          }

        }else{
          return this.displayDates(dates[0], dates[1], formatAMPM);
        }

      } else {
        /*
        if (value === DateEncoding.ALL_DAY){
          if (formatAMPM){
            return '0:00 am - 0:00 am'
          }else{
            return '00:00 - 24:00';
          }
        }else{
        */
          console.log('DisplayInterval found ' + dates.length + ' dates in interval');
          return '';
        //}
      }

    }

  public displayDates(begin: Date, end: Date, formatAMPM: boolean, roundWhenCloseToMidnight: boolean = false,verifyDateAreNull:boolean=false):string {
    let startStr = 'xx:xx';
    let endStr = 'xx:xx'
    if (formatAMPM) {
      startStr = 'xx:xx AM';
      endStr = 'xx:xx AM'
      if (verifyDateAreNull){
        if (begin){
          startStr =  moment(begin).format('hh:mm A');
        }
        if (end){
          endStr =  moment(end).format('hh:mm A');
        }
      }else{
        startStr =  moment(begin).format('hh:mm A');
        endStr =  moment(end).format('hh:mm A');
      }
    }else {
      if (verifyDateAreNull){
        if (begin){
          startStr = moment(begin).format('HH:mm');
        }
        if (end){
          endStr = moment(end).format('HH:mm');
          /**
           * Issue noticed by Dorine. I595
           */
          if (roundWhenCloseToMidnight && (moment(end).hour() === 23) && (moment(end).minute() > 30)) {
            endStr = '24:00';
          }
        }

      }else{
        startStr = moment(begin).format('HH:mm');
        endStr = moment(end).format('HH:mm');
        /**
         * Issue noticed by Dorine. I595
         */
        if (roundWhenCloseToMidnight && (moment(end).hour() === 23) && (moment(end).minute() > 30)) {
          endStr = '24:00';
        }
      }
    }
    return startStr + ' - ' + endStr;
  }


}
